/**
 * Import des stratégies
 */
import SearchStrategyEnum from '@/enums/commons/SearchStrategyEnum';
import { SearchStrategy } from './SearchStrategy';
import { NodeSearchStrategy } from './NodeSearchStrategy';
import { ShortLBOSearchStrategy } from './ShortLBOSearchStrategy';
import { ShortMeterSearchStrategy } from './ShortMeterSearchStrategy';


// Définition du type pour le constructeur de stratégie
type StrategyConstructor = new () => SearchStrategy;

/**
 * Mappe l'énumération SearchStrategyType aux classes de stratégie correspondantes.
 * Cela permet une gestion des stratégies par dictionnaire, évitant un long 'switch' ou 'if/else'.
 */
const strategyMap: Record<SearchStrategyEnum, StrategyConstructor> = {
    [SearchStrategyEnum.INodeSearch]: NodeSearchStrategy,
    [SearchStrategyEnum.IShortMeterSearch]: ShortMeterSearchStrategy,
    [SearchStrategyEnum.IShortLBOSearch]: ShortLBOSearchStrategy
};

/**
 * Classe Factory statique pour créer des instances de stratégies de recherche.
 * Elle permet de découpler l'instanciation des stratégies du composant appelant.
 */
export class SearchStrategyFactory {
    
    /**
     * Crée et retourne une instance de stratégie de recherche basée sur le type fourni.
     * @param type Le type de stratégie à instancier (issu de l'énumération SearchStrategyType).
     * @returns Une nouvelle instance de la stratégie demandée.
     */
    public static createStrategy(type: SearchStrategyEnum): SearchStrategy {
        const StrategyClass = strategyMap[type];

        if (StrategyClass) 
            return new StrategyClass();

        return new NodeSearchStrategy();
    }
}